import React, { useEffect, useRef } from 'react';
import PaymentForm, { PaymentFormHandle } from 'components/billing/PaymentForm/PaymentForm';
import Button from 'components/shared/Button';
import styles from './CardInfo.module.scss';
import { useNavigate } from 'react-router-dom';
import { useCardInfoContext } from '../contexts/CardInfoContext';
import PageTitle from 'components/shared/PageTitle';

const CardInfo: React.FC = () => {
  const navigate = useNavigate();
  const { setCardInfoFormRef } = useCardInfoContext();

  const cardInfoFormRef = useRef<PaymentFormHandle>(null);

  useEffect(() => {
    setCardInfoFormRef(cardInfoFormRef as React.RefObject<any>);
    return () => setCardInfoFormRef(null);
  }, [cardInfoFormRef, setCardInfoFormRef]);

  return (
    <div className={styles.cardInfo}>
      <PageTitle title={`Payment Information`} />

      <PaymentForm ref={cardInfoFormRef} />

      <Button
        variant="default"
        onClick={() => navigate("/payment")}
        style={{ maxWidth: 120, marginTop: 16 }}
      >
        Previous
      </Button>
    </div>
  );
};

export default CardInfo;
